/*
Monotype Foundry Platform API
Version 1.0.0

Definition: CreateDropShipRequest

Properties:
  projectName: string (required), minLength: 3, maxLength: 100
  type: string (required)
  foundryId: string (required)
*/

var CreateDropShipRequest = (function () {
  function validateCreateDropShipRequest (arg) {
    // Validate projectName
    if (!arg.projectName) {
      throw new Error('CreateDropShipRequest.projectName: Missing property')
    }
    if (arg.projectName && !(typeof arg.projectName === 'string')) {
      throw new Error('CreateDropShipRequest.projectName: Wrong type: Got \'' + (typeof arg.projectName) + '\', but expected: \'string\'')
    }
    if (arg.projectName && !(arg.projectName.length >= 3)) {
      throw new Error('CreateDropShipRequest.projectName: Minimum length 3, but got: ' + arg.projectName.length)
    }
    if (arg.projectName && !(arg.projectName.length <= 100)) {
      throw new Error('CreateDropShipRequest.projectName: Maximum length 100, but got: ' + arg.projectName.length)
    }
    // Validate type
    if (!arg.type) {
      throw new Error('CreateDropShipRequest.type: Missing property')
    }
    if (arg.type && !(typeof arg.type === 'string')) {
      throw new Error('CreateDropShipRequest.type: Wrong type: Got \'' + (typeof arg.type) + '\', but expected: \'string\'')
    }
    // Validate foundryId
    if (!arg.foundryId) {
      throw new Error('CreateDropShipRequest.foundryId: Missing property')
    }
    if (arg.foundryId && !(typeof arg.foundryId === 'string')) {
      throw new Error('CreateDropShipRequest.foundryId: Wrong type: Got \'' + (typeof arg.foundryId) + '\', but expected: \'string\'')
    }
  }
  function buildCreateDropShipRequest (arg) {
    var CreateDropShipRequest = arg
    // Complete projectName
    // Expected Type: string
    CreateDropShipRequest.projectName = CreateDropShipRequest.projectName || ''
    // Complete type
    // Expected Type: string
    CreateDropShipRequest.type = CreateDropShipRequest.type || ''
    // Complete foundryId
    // Expected Type: string
    CreateDropShipRequest.foundryId = CreateDropShipRequest.foundryId || ''
    return CreateDropShipRequest
  }
  return {
    validate: validateCreateDropShipRequest,
    build: buildCreateDropShipRequest
  }
})()

module.exports = CreateDropShipRequest
